// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tdyG","question":"styles_question__s2zbG","inputVisibleButton":"styles_inputVisibleButton__2XjHW","note":"styles_note__1LQy0"};